import { Flex } from '@chakra-ui/react'
import { DateRange } from '~/types/Shared'

import { HeatmapDirection } from '../Shared/HeatmapDirectionDropdown'
import AnsweredCallHeatmap from './AnsweredCallHeatmap'
import CallVolumeHeatmap, { HeatmapTimeRange } from './InboundHeadmap'
import MissedCallHeatmap from './MissedCallHeatmap'
import OutboundCallHeatmap from './OutboundHeatmap'

interface HeatMapDashboardProps {
  sharedDateRange?: DateRange
  timeRangeMode: HeatmapTimeRange
  direction: HeatmapDirection
}

export default function HeatMapDashboard({
  sharedDateRange,
  timeRangeMode,
  direction,
}: HeatMapDashboardProps) {
  const dateTimeRange = sharedDateRange ?? {
    before: new Date(),
    after: new Date(new Date().setDate(new Date().getDate() - 7)),
  }

  return (
    <Flex direction="column" gap="1.25rem" w="100%">
      {direction === 'answered' && (
        <>
          <MissedCallHeatmap
            dateTimeRange={dateTimeRange}
            timeRangeMode={timeRangeMode}
          />
          <AnsweredCallHeatmap
            dateTimeRange={dateTimeRange}
            timeRangeMode={timeRangeMode}
          />
        </>
      )}
      {direction === 'direction' && (
        <>
          <CallVolumeHeatmap
            dateTimeRange={dateTimeRange}
            timeRangeMode={timeRangeMode}
          />
          <OutboundCallHeatmap
            dateTimeRange={dateTimeRange}
            timeRangeMode={timeRangeMode}
          />
        </>
      )}
    </Flex>
  )
}
